import React from 'react'
import { useTranslation } from 'react-i18next'

import SegmentedSelector from './SegmentedSelector'
import { PLATFORMS } from '../constants'
import { ProductAnalyticsPlatform } from '../types'

type PlatformSelectorProps = {
  value: ProductAnalyticsPlatform
  onChange: (platform: ProductAnalyticsPlatform) => void
}

const PlatformSelector: React.FC<PlatformSelectorProps> = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <SegmentedSelector
      value={value}
      options={PLATFORMS}
      onChange={onChange}
      getOptionLabel={platform => t(`stats.product_analytics.platform.${platform}`)}
      ariaLabel={t('stats.product_analytics.platform.label')}
    />
  )
}

export default PlatformSelector
